import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabLeappHProbe from "../../Assets/Bluelab Leap pH Probe.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Bluelab_Leap_pH_Probe = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 34,
      name: "Bluelab Leap pH Probe",
      price: 10248,
      image: BluelabLeappHProbe,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabLeappHProbe}
                  alt="bluelab leap pH probe"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Bluelab Leap pH Probe</h2>
            <p className="product-price">₹{10248}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>Fast and Accurate pH Measurements for Any Substrate</h5>
              Get precise pH readings in seconds with this reinforced spear-tip
              pH probe, designed for direct measurement in a variety of
              substrates, including soil, coco coir blends, rockwool, potting
              mixes, and solution. The double-junction probe minimizes reference
              contamination, significantly extending its life and reliability.
              <h5 className="mt-3">Key Features:</h5>
              <ul>
                <li>
                  Reinforced spear-tip ensures quick and direct pH measurement
                  in all types of substrates.
                </li>
                <li>
                  Highly effective for use in soil, coco coir, and rockwool,
                  ensuring versatile application across various growing media.
                </li>
                <li>
                  The fast sensor response provides accurate readings in just
                  seconds, allowing you to make quick adjustments when
                  necessary.
                </li>
                <li>
                  The BNC connector is protected from corrosion, ensuring
                  durability and long-term use.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_Leap_pH_Probe;
